import { render, staticRenderFns } from "./Black1.vue?vue&type=template&id=218c68f4&"
import script from "./Black1.vue?vue&type=script&lang=js&"
export * from "./Black1.vue?vue&type=script&lang=js&"
import style0 from "./estilo.styl?vue&type=style&index=0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports